import React from "react";
import { BinningDisplayValue } from "./../../../Model/ImagerCapabilities";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";

type Props = {
  binningDisplayValues: BinningDisplayValue[];
  value: number;
  style: React.CSSProperties;
  onChange: (name: string, value: number) => void;
  name: string;
  disabled: boolean;
};

export default function DefaultImagingSettingBinning({
  binningDisplayValues,
  value,
  style,
  onChange,
  name,
  disabled,
}: Props) {
  var dropDownDisplayValues = binningDisplayValues.map((binningDisplayValue) => {
    const { binning, resolution, resolutionUnit } = binningDisplayValue;
    const display =
      resolution.toFixed(2) +
      " " +
      resolutionUnit +
      " (" +
      binning +
      "x" +
      binning +
      " binning)";

    return { display: display, value: binning, disabled: false };
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "flex-start",
        color: disabled ? "#808080" : "#000000",
        ...style,
      }}
    >
      <div
        style={{
          width: 125,
          lineHeight: "16px",
          fontSize: "13px",
          textAlign: "left",
          margin: "Auto 0px"
        }}
      >
        Binning
      </div>
      <CommonDropDown
        style={{
          width: "253px",
          height: "34px",
          color: disabled ? "#808080" : "#000000",
          backgroundColor: disabled? "rgba(204, 204, 204, 0.1)" : "#FFFFFF",
          borderColor: disabled? "rgba(133, 133, 133, 0.3)" : "rgb(133, 133, 133)",
          fontSize: 13.3
        }}
        onChange={(value) => onChange(name, value)}
        value={value}
        id={name}
        disabled={disabled}
        dropDownDisplayValues={dropDownDisplayValues}
      />
    </div>
  );
}
